import PlantSubServicePage from "@/components/PlantSubServicePage";

const RELATED = [
  { to: "/piping", label: "Piping" },
  { to: "/civil-structural", label: "Civil & Structural" },
  { to: "/electrical-instrumentation", label: "Electrical & Instrumentation" },
  { to: "/mechanical", label: "Mechanical" },
];

const MTC_DETAILS = [
  {
    sectionTitle: "Roles & details we verify in every MTC",
    title: "Manufacturer Information",
    items: ["Name and address of the manufacturer", "Logo and contact details"],
  },
  {
    title: "Product Description",
    items: [
      "Material grade (e.g., ASTM A106 Gr. B)",
      "Size, thickness, length and other dimensions",
      "Heat number (unique for traceability)",
    ],
  },
  {
    title: "Standards & Specifications",
    items: [
      "Standards followed (e.g., ASTM, ASME, EN)",
      "Compliance declaration with specific material standards",
    ],
  },
  {
    title: "Chemical Composition",
    items: ["% of elements like C, Mn, P, S, Si, etc.", "Must match the specified standard"],
  },
  {
    title: "Mechanical Properties",
    items: ["Yield Strength", "Tensile Strength", "Elongation", "Hardness"],
  },
  {
    title: "Heat Treatment (if applicable)",
    items: ["Type of heat treatment (e.g., normalised, annealed)"],
  },
  {
    title: "Testing Details",
    items: [
      "Test methods (e.g., tensile test, impact test)",
      "Results of those tests",
      "Test temperature (for impact tests)",
    ],
  },
  {
    title: "Certifying Authority",
    items: ["QA/QC signature", "Stamp of the certifying body", "Date of issue"],
  },
  {
    title: "Certificate Type",
    items: ["EN 10204 types: 2.1, 2.2, 3.1, 3.2"],
  },
  {
    title: "Additional Notes",
    items: ["Any special instructions or conditions", "Country of origin, if required"],
  },
];

export default function Materials() {
  return (
    <PlantSubServicePage
      slug="materials"
      title="Material (Certification Verification)"
      lead="MTC inspection and approval across pipe fittings, valves, civil profiles, equipment and electrical components — strict EN 10204 compliance."
      intro={[
        "At ZeroLabs, our team brings proven expertise in reviewing and validating Material Test Certificates (MTCs) across a diverse range of vendor-supplied documentation. We specialise in the inspection and approval of critical client components — pipe fittings, valves, civil profiles, equipment and electrical parts.",
        "We ensure compliance with the EN 10204 standard, covering 2.1 (Declaration of compliance), 2.2 (Test reports — basic compliance and non-specific test results), 3.1 (Inspection certificate issued by the manufacturer's authorised inspector with actual test results for the specific material), and 3.2 (Inspection certificate jointly verified by the manufacturer and an independent third-party inspector).",
        "Our attention to detail and deep understanding of compliance standards ensure that only the highest quality materials are approved for our clients.",
      ]}
      industries={["Oil & Gas", "Refining", "Petrochemicals", "Power", "Water Treatment", "Paper & Pulp"]}
      bullets={MTC_DETAILS}
      tools={["EN 10204", "ASTM", "ASME", "API"]}
      heroImage="https://www.thantrick.com/wp-content/uploads/2025/04/MTC-1024x1024.jpg"
      gallery={[
        "https://www.thantrick.com/wp-content/uploads/2025/04/Material-300x300.jpg",
        "https://www.thantrick.com/wp-content/uploads/2025/04/MTC-300x300.jpg",
      ]}
      thantrickUrl="https://thantrick.org/materials/"
      related={RELATED}
    />
  );
}
